import React from 'react';

const SearchBarButton = React.forwardRef((props, ref) => {
  const { children, className, refProp, active, ...other } = props;
  return (
    <button ref={ref} className={`${className} searchbar__button ${active ? 'active' : ''}`} {...other}>
      {children}
    </button>
  );
});

export default SearchBarButton;
